import { useEffect, useRef, useState } from 'react';
import { useInView, animate } from 'framer-motion';
import { EASE_OUT } from '@/lib/motion';

/**
 * Counts up from 0 to `value` once it enters the viewport. For stat/KPI
 * callouts (e.g. "500+ brands generated").
 */
const AnimatedCounter = ({ value, prefix = '', suffix = '', duration = 1.4, decimals = 0, className }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!isInView) return undefined;
    const controls = animate(0, value, {
      duration,
      ease: EASE_OUT,
      onUpdate: (v) => setDisplay(v),
    });
    return () => controls.stop();
  }, [isInView, value, duration]);

  return (
    <span ref={ref} className={className}>
      {prefix}
      {display.toFixed(decimals)}
      {suffix}
    </span>
  );
};

export default AnimatedCounter;
